const config = {
  SOCKET_IO_DEBUG: false,
  JANUS_HOST: 'wss://webrtc-dev1.freshvoice.asia/janus',
  API_HOST: 'webrtc-dev1.freshvoice.asia',
  TURN_HOST: 'turn.workshop.tokyo',
  SOCKET_HOST: 'webrtc-dev1.freshvoice.asia',
  WEBINAR_ADMIN_URL: 'https://admin-dev.workshop-live.com',
  DD_ADMIN_URL: 'https://admin-dev.dd-talk.net/',
  SHARE_URL: 'https://video-dev.dd-talk.net',
  FIREBASE_BASE: 'dev',
  FIREBASE_CONFIG: {
    apiKey: 'AIzaSyDr-X8Je_yrq4_mSXZlqh0TTOfEyFkGuuo',
    authDomain: 'workshop-video-dev-1982d.firebaseapp.com',
    databaseURL: 'https://workshop-video-dev-1982d.firebaseio.com',
    projectId: 'workshop-video-dev-1982d',
    storageBucket: 'workshop-video-dev-1982d.appspot.com',
    messagingSenderId: '748861615882'
  },
  WEBINAR_DEV_TEST2_DEBUG_TOKEN: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJub25lIn0.eyJjb25mZXJlbmNlX2lkIjoyNzksInVzZXJfaWQiOjYzLCJhZG1pbiI6InllcyIsImNvbmZlcmVuY2VfbmFtZSI6InRlc3QyLXdlYnJ0Yy1kZXYxLmZyZXNodm9pY2UuYXNpYSIsImNvbmZlcmVuY2VfZGVzY3JpcHRpb24iOm51bGx9.',
  WEBINAR_PROD_TEST2_DEBUG_TOKEN: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJub25lIn0.eyJjb25mZXJlbmNlX2lkIjoxNTcwLCJ1c2VyX2lkIjoxNiwiYWRtaW4iOiJ5ZXMiLCJjb25mZXJlbmNlX25hbWUiOiJwcm9kMi13b3Jrc2hvcC50b2t5byIsImNvbmZlcmVuY2VfZGVzY3JpcHRpb24iOm51bGx9.',
  SENTRY: 'https://66a006f052304deab9664dbc41633a6f@sentry.io/1497479',
  GIT_HASH: "1fb2012",
  GIT_BRANCH: "master"
}
export default config



// WEBPACK FOOTER //
// ./src/config/config.js